module.exports = __webpack_public_path__ + "img/model_13.e839623e.jpg";